// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1B3cW","categoryItem":"styles_categoryItem__3bfmV","subCategoryItem":"styles_subCategoryItem__1KzTZ","categoryList":"styles_categoryList__2kQz8"};